module.exports = __webpack_public_path__ + "static/media/cronos.6ceccae5.svg";